
import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/navigation/Header.vue';
import NavBar from '@/components/navigation/NavBar.vue';
import { mapGetters } from 'vuex';

@Component({
    components: {
        Header,
        NavBar,
    },
    computed: {
        ...mapGetters({
            getUser: 'authenticationStorage/getUser',
            isAuthenticated: 'authenticationStorage/isAuthenticated',
        }),
    },
})
export default class Layout extends Vue {
    isAuthenticated!: boolean;

    private static readonly AUTHENTICATED_LAYOUT_CLASS =
        'authenticated-layout-active';

    mounted(): void {
        this.updateBodyScrollState(this.isAuthenticated);
    }

    beforeDestroy(): void {
        this.updateBodyScrollState(false);
    }

    @Watch('isAuthenticated')
    onAuthenticationChanged(isAuthenticated: boolean): void {
        this.updateBodyScrollState(isAuthenticated);
    }

    @Watch('$route')
    onRouteChanged(): void {
        this.$nextTick(() => {
            this.resetInnerLayoutScroll();
        });
    }

    resetInnerLayoutScroll(): void {
        globalThis.scrollTo(0, 0);

        const innerLayout = this.$refs.innerLayout as HTMLElement | undefined;

        if (innerLayout) {
            innerLayout.scrollTop = 0;
            innerLayout.scrollLeft = 0;
        }
    }

    updateBodyScrollState(isAuthenticated: boolean): void {
        [document.documentElement, document.body].forEach((element) => {
            element.classList.toggle(
                Layout.AUTHENTICATED_LAYOUT_CLASS,
                isAuthenticated,
            );
        });
    }

    navlessRoutes = [
        '/not-found',
        '/login',
        '/signup',
        '/reset-password-request',
        '/reset-password',
    ];

    checkIfRouteIsNavless(): boolean {
        return (
            this.navlessRoutes.includes(this.$route.path) ||
            (!this.isAuthenticated && this.$route.name === 'Sheet')
        );
    }
}
